import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ApplicationUserService } from 'src/app/core/applicationuser.service';
import { Column } from 'src/app/shared/models/column.model';

@Component({
  selector: 'app-application-users-list',
  templateUrl: './application-users-list.component.html',
  styleUrls: ['./application-users-list.component.scss']
})
export class ApplicationUsersListComponent implements OnInit{
  cols!: Column[];
  selectedUsers:any;
  displayConfirmationDialog = false;
  userToBeDeleted: string ='';
  confirmUserDelete = false;
  searchQuery: string = '';

  constructor(private router: Router,public userService: ApplicationUserService,    private spinner: NgxSpinnerService
    ) {
    
   }

   ngOnInit(): void {
    this.cols = [
      { field: 'username', header: 'User Name',sortable: true } ,
      { field: 'company', header: 'Company' ,sortable: true},
      { field: 'sinequaProfile', header: 'Sinequa Profile',sortable: true },
      { field: 'role', header: 'Role',sortable: true },
      { field: 'contactEmail', header: 'Contact Email',sortable: true }
    ];    
    this.getApplicationUsers();
  }
  async getApplicationUsers(){
    this.spinner.show();
    const emtpyQuery = '' ;
    this.userService.getUsers(emtpyQuery).subscribe((response: any) => {
      this.userService.data = response; // Populate the data array with the API response
      this.spinner.hide();
    });  

  }
  navigateToNew() {
    this.router.navigate(['/application-user-new']);
  }
  deleteUser(username:string){
    this.userToBeDeleted = username;
    this.displayConfirmationDialog = true;
  }
  goBack() {
    this.displayConfirmationDialog = false; // Close the dialog

  }
  async confirmDelete() {
    this.confirmUserDelete = true;
    this.displayConfirmationDialog = false; // Close the dialog
    if(this.confirmUserDelete){
      await this.userService.deleteUser(this.userToBeDeleted);
    }
    if(this.userService.userDeletedStatus){
      this.getApplicationUsers();
    }
  }
  navigateToDetail(rowData: any) {
    this.userService.setUser(rowData);
    this.router.navigate(['/application-user-detail'], { queryParams: { uid: rowData.uid } });
  }
  onSearchInputChange(query: string): void {
    this.userService.data = [];
    this.spinner.show();
    this.userService.getUsers(query).subscribe((result: any) => {
      this.userService.data = result; // Populate the data array with the API response
      this.spinner.hide();

    });
  }
  isSearchActive = false;

  toggleSearch() {
      this.isSearchActive = !this.isSearchActive;
  }
      isSearchExpanded: boolean = false;

    expandSearchBar() {
        this.isSearchExpanded = true;
    }

    collapseSearchBar() {
        this.isSearchExpanded = false;
    }

}
